import styled from 'styled-components';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 700px;
  height: 350px;
  & input, textarea {
    font-size: 14px !important;
  }
  & > div + div {
    margin-top: .5rem;
  }
`;

export const VarTip = styled.span`
  color: ${({ theme }) => theme.color};
  font-size: 14px;
  margin-bottom: 0.5rem;
`;

export const InputRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  & .select-wrapper {
    max-width: 50px;
  }
  & > * {
    margin-right: 1rem;
    &:last-child {
      margin-right: 0;
    }
  }
  & .code-textarea {
    width: 100%;
    height: 100%;
    border-radius: 5px;
    border: 1px solid ${({ theme }) => theme.inputBottomLine};
    border-radius: 5px;
  }
  & .extra-label {
    color: ${({ theme }) => theme.inputLabel};
    margin-left: auto;
  }
`;
